//componente react per gestire il messaggio di cancellazione pagamento con PayPal
import React from 'react';
import Page from '../layout/Page';
import Card from '../layout/Card';


export default function Cancel() {
    return (
         <Page title={"Pagamento annullato"} >
            <Card content={
                <div className="paypal-page">
                    <p>Il pagamento è stato annullato. Se hai bisogno di assistenza, contatta il supporto.</p>
                    <p>Puoi tornare alla pagina principale o riprovare il pagamento.</p>
                    <a href="/" className="btn btn-primary">Torna alla Home</a>
                </div>
            } />
         </Page>
    );
}
